// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AEIu69cf0xwN1jTs7fTb{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.AEIu69cf0xwN1jTs7fTb .nzx0oDrcKtn4vJRFZywN{max-width:1024px;width:100%;height:100%}.AEIu69cf0xwN1jTs7fTb .K3ddGBCQU2bXvrCP9QFK{margin:auto;height:100%;display:flex;justify-content:center;flex-direction:column}.AEIu69cf0xwN1jTs7fTb .K3ddGBCQU2bXvrCP9QFK .G_xb50BPFL3kqWubkJh5{flex:0;text-align:bottom}.AEIu69cf0xwN1jTs7fTb .K3ddGBCQU2bXvrCP9QFK .OIrFmz94mE_zJt3rRhbp{font-weight:500}.AEIu69cf0xwN1jTs7fTb .K3ddGBCQU2bXvrCP9QFK .tB8VE_jWFL2hNR6MVuAc{color:var(--color-sa-gray)}.AEIu69cf0xwN1jTs7fTb .K3ddGBCQU2bXvrCP9QFK p{flex:0 0}.AEIu69cf0xwN1jTs7fTb .K3ddGBCQU2bXvrCP9QFK strong{font-weight:500}.AEIu69cf0xwN1jTs7fTb .K3ddGBCQU2bXvrCP9QFK .cS19e1RknF3ZgTNYTsw9{color:#6e32f0;font-size:14px;text-align:center;margin-top:4em;flex:0 1 20px}.AEIu69cf0xwN1jTs7fTb .I3EZ0yZ54yMNb6q7twyu{width:100% !important;max-width:100% !important}.AEIu69cf0xwN1jTs7fTb .G_xb50BPFL3kqWubkJh5{color:#6e32f0;text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.6rem;text-transform:uppercase}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `AEIu69cf0xwN1jTs7fTb`,
	"rightComponent": `nzx0oDrcKtn4vJRFZywN`,
	"carouselItem": `K3ddGBCQU2bXvrCP9QFK`,
	"title": `G_xb50BPFL3kqWubkJh5`,
	"quote": `OIrFmz94mE_zJt3rRhbp`,
	"note": `tB8VE_jWFL2hNR6MVuAc`,
	"thanks": `cS19e1RknF3ZgTNYTsw9`,
	"image": `I3EZ0yZ54yMNb6q7twyu`
};
export default ___CSS_LOADER_EXPORT___;
